import { useEffect } from 'react';
import { RefreshCw } from 'lucide-react';
import {
  ensureFantasyDataSynced,
  getPlayersFromFirestore,
} from '../firebase/playerService';
import useFantasyDataSyncing from '../hooks/useFantasyDataSyncing';
import './DataSyncBootstrap.css';

export default function DataSyncBootstrap() {
  const { syncing, progress, source } = useFantasyDataSyncing();
  const isRemote = source === 'remote';

  useEffect(() => {
    ensureFantasyDataSynced()
      .then(() => getPlayersFromFirestore())
      .catch(console.error);
  }, []);

  if (!syncing) return null;

  return (
    <div className="data-sync-banner" role="status" aria-live="polite">
      <div className="data-sync-banner__head">
        <RefreshCw size={16} className="data-sync-banner__icon" aria-hidden="true" />
        <span>{isRemote ? 'Sincronizzazione in corso su un altro dispositivo…' : 'Sincronizzazione dati in corso…'}</span>
        <strong className="data-sync-banner__pct">{Math.round(progress)}%</strong>
      </div>
      <div className="data-sync-banner__bar">
        <i style={{ width: `${Math.max(4, progress)}%` }} />
      </div>
      <span className="data-sync-banner__hint">
        {isRemote
          ? 'Appena finisce, i dati aggiornati vengono letti direttamente da Firebase.'
          : 'Attendi il termine per avere il dataset aggiornato.'}
      </span>
    </div>
  );
}
